'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveItemRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveItemRemote = exports.SaveItemRemote = {
    fetchSavedItemCounts: function fetchSavedItemCounts(_ref) {
        var deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/count', deployment);
            request.send({ ids: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSaveItem: function postSaveItem(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/save/' + itemId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemId: itemId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsaveItem: function postUnsaveItem(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            itemId = _ref3.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/unsave/' + itemId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemId: itemId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/saveItem.js
// module id = JuF/
// module chunks = 57